/* eslint-disable @typescript-eslint/no-unused-vars */
import { useTheme } from '@mui/material'
import ErrorFallbackView from 'components/error-fallback/error-fallback-view'
import { PrivateRoute } from 'components/private-route'
import { Spinner } from 'components/spinner'
import { ThemeProvider } from 'components/theme-provider'
import { AddonSelectorContext } from 'pages/addon-selector-page/contexts/addon-selector-context'
import SummaryPage from 'pages/addon-selector-page/pages/summary-page'
import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom'

const AddonSelectorPage = React.lazy(() => import('pages/addon-selector-page'))
const FinishPage = React.lazy(() => import('pages/addon-selector-page/pages/finish-page'))
const LandingPage = React.lazy(() => import('pages/landing-page'))
const NotFoundPage = React.lazy(() => import('pages/not-found-page'))
const WelcomePage = React.lazy(() => import('pages/welcome-page'))

const ProjectFallback = () => {
  return (
    <h3>No project id found. Please use http://url.to.app/?projectId=[projectId] as root url</h3>
  )
}

export const App = () => (
  <ErrorBoundary FallbackComponent={ProjectFallback} onReset={() => window.location.reload()}>
    <ThemeProvider>
      <PagesContainer />
    </ThemeProvider>
  </ErrorBoundary>
)

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<ErrorFallbackView />}>
      <Route path="/" element={<LandingPage />} />
      <Route element={<PrivateRoute />}>
        <Route path="welcome" element={<WelcomePage />} />
        <Route
          element={
            <AddonSelectorContext.Provider>
              <Outlet />
            </AddonSelectorContext.Provider>
          }>
          <Route path="addon-selector" element={<AddonSelectorPage />} />
          <Route path="addon-selector/summary" element={<SummaryPage />} />
        </Route>
        <Route path="finish" element={<FinishPage />} />
      </Route>
    </Route>
  )
)

function PagesContainer() {
  const theme = useTheme()
  return (
    <ErrorBoundary FallbackComponent={ErrorFallbackView} onReset={() => window.location.reload()}>
      <React.Suspense
        fallback={
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}>
            <Spinner color={theme.palette.primary.main} />
          </div>
        }>
        <RouterProvider router={router} />
      </React.Suspense>
    </ErrorBoundary>
  )
}
